import { render, staticRenderFns } from "./all_products.vue?vue&type=template&id=c8f3a8d0&"
import script from "./all_products.vue?vue&type=script&lang=js&"
export * from "./all_products.vue?vue&type=script&lang=js&"
import style0 from "./all_products.vue?vue&type=style&index=0&id=c8f3a8d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports